import type { Segmento } from "../tipos";
import s from "./TextoMensaje.module.css";

/* El texto del mensaje tal como va a salir; en modo plantilla, las variables en violeta. */
export function TextoMensaje({ segmentos }: { segmentos: Segmento[] }) {
  return (
    <div className={s.texto}>
      {segmentos.map((seg, i) =>
        seg.variable ? (
          <mark key={i} className={s.variable}>
            {seg.texto}
          </mark>
        ) : (
          <span key={i}>{seg.texto}</span>
        ),
      )}
    </div>
  );
}
